import { CreateEtZone, UpdateEtZone } from '@/types'
import { SearchParams } from '@/types/common'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const etZoneDataConfig = {
  getAll(interfaceId: string, searchParams: SearchParams = {}) {
    const url = `/api/etzone/${interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId: string, id: string) {
    const url = `/api/etzone/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: CreateEtZone) {
    const url = '/api/etzone'
    return axiosClient.post(url, payload)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/etzone/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },
  update(payload: UpdateEtZone) {
    const url = '/api/etzone'
    return axiosClient.put(url, payload)
  },
}

export default etZoneDataConfig
